import React, {  useState, useEffect }  from "react";
import { getUserFactoryId, getStructureTree } from '../../../index';
import "./AddStructureOrganizationPage.css";
import {ModalOk} from '../../components/ModalOk/ModalOk';
// import { getStructure, getResponsabilidades, postStructure, putStructure } from './actions';
import { getStructure, postStructure, putStructure } from './actions';
import { CircularProgress, Grid, TextField } from '@material-ui/core';
import {Button,Form , Modal, ToggleButtonGroup} from 'react-bootstrap';
import { Link, useHistory } from "react-router-dom";
import TreeMenu, { ItemComponent } from 'react-simple-tree-menu';
import { getStructureTreeBancoDeDados } from '../../modules/Auth/_redux/authCrud';
import { Loading } from "../../components/Loading/Loading";

const listClassificao = [
	{
		id: 1,
		label: 'TLF',
	},
	{
		id: 2,
		label: 'Setor',
	},
	{
		id: 3,
		label: 'LL',
	},
	{
		id: 4,
		label: 'SubLL',
	},
	{
		id: 5,
		label: 'Grupo',
	},
	{
		id: 6,
		label: 'Linha',
	},
	{
		id: 7,
		label: 'Pilar',
	},
	{
		id: 8,
		label: 'Máquina',
	},
	{
		id: 9,
		label: 'Ativo',
	},
  ];

export default function AddStructureOrganizationPage (props){
	const history = useHistory();
	const idStructure = props.match.params?.id;
	const isAdd = props.match.url.split('/')[2].includes('add');
	const [factoryId, setFactoryId] = useState()
	// console.log(user);
	const [treeData, setTreeData] = useState([{ key: 'test', label: 'Carregando...', nodes: [] }]);

	const [showModalOk, setShowModalOk] = useState(false);
	const [msgErro, setMsgErro] = useState('');
	const abrirModalOk = (_msg) =>  {setMsgErro(_msg); setShowModalOk(true)};

	const [showModalSuccess, setShowModalSuccess] = useState(false);
	const [msgSuccess, setMsgSuccess] = useState('');
	const abrirModalSuccess = (_msg) =>  {setMsgSuccess(_msg); setShowModalSuccess(true)};

	const [structure, setStructure] = useState({});
	const [loading, setLoading] = useState(false);

	const [showModalSetor, setShowModalSetor] = useState(false);
	const fecharModalSetor = () => setShowModalSetor(false);
	const abrirModalSetor = () => setShowModalSetor(true);

	const [inputNome, setInputNome] = useState('');
  	const [inputNomeErro, setInputNomeErro] = useState(false);
	const [inputTipo, setInputTipo] = useState(listClassificao[0].id);
  	const [inputTipoErro, setInputTipoErro] = useState(false);
	const [inputTPM, setInputTPM] = useState(0);
  	const [inputTPMErro, setInputTPMErro] = useState(false);
	const [inputCode, setInputCode] = useState('');
  	const [inputCodeErro, setInputCodeErro] = useState(false);
	
	const [inputSetorArea, setInputSetorArea] = useState({label:"", id:null});
  	const [inputSetorAreaErro, setInputSetorAreaErro] = useState(false);
	const [load, setLoad] = useState(false);
	const [valueStatus, setValueStatus] = React.useState(true);
	const handleChangeStatus = val => setValueStatus(val);

	
	const proximoPasso = async ()=>{
		setLoading(true);

		setInputNomeErro(false);
		setInputTPMErro(false);
		setInputCodeErro(false);

		if (inputCode == '' && inputTipo != 9) {
			setInputCode(inputNome);
        }

		if(inputNome == ''){
			abrirModalOk('Campo Nome precisa ser preenchido!');
			setInputNomeErro(true);
		} else if (inputCode == '' && inputTipo == 9) {
			abrirModalOk('Campo FLOC(código do ativo) precisa ser preenchido!');
			setInputCodeErro(true);
		}else if(inputTipo == 6 && inputTPM <= 0){
			abrirModalOk('Informe a quantidade de passos TPM!');
			setInputTPMErro(true);
		}else if(parseInt(inputSetorArea.id) == parseInt(idStructure) && !isAdd){
			abrirModalOk('Uma estrutura não pode ser pai dela mesma');
			setInputSetorAreaErro(true);
		}
		else if (parseInt(inputSetorArea.id) == null || inputSetorArea.id == null) {
			abrirModalOk('Uma estrutura precisa de um pai');
			setInputSetorAreaErro(true);
		} else {
			let body = {
				"Name": inputNome,
				"Code": (inputCode == '' && inputTipo != 9) ? inputNome : inputCode,
				"TypeId": parseInt(inputTipo),
				"StepTpm": inputTPM,
				"FactoryId": factoryId,
				"FatherId": parseInt(inputSetorArea.id),
				"Status": valueStatus,
			}
			console.log(body);
			if(isAdd){
				//adicionar estrutura
				if(await postStructure(body)){
					await atualizarEstrutura();
					abrirModalSuccess('Estrutura adicionada com sucesso!');
				}else{
					abrirModalOk('Ops... Não foi possivel salvar as informacões!\nTente novamente!');
				}
			}else{
				//editar estrutura
				body['id'] = idStructure;
				if(await putStructure(body)){
					await atualizarEstrutura();
					abrirModalSuccess('Estrutura editada com sucesso!');
				}else{
					abrirModalOk('Ops... Não foi possivel salvar as informacões!\nTente novamente!');
				}
			}
		}

		setLoading(false);
	};

	const handleModalSuccess = ()=>{
		history.push('/StructureOrganizations');
	};

	const handleShow = async (e) => {
		console.log(e)
		setInputSetorArea({ label: e.label, id: e.structureId});
	};

	const handleTipo = (value)=>{
		setInputTipo(value);

		switch (value) {
			case '1':{
				//TLF maior valor da fabrica
				let maiorFabrica = checarNodesMaiorValorTPM(treeData);
				setInputTPM(maiorFabrica);
				break;
			}
			case '2':{
				//Setor maior valor da fabrica
				let maiorFabrica = checarNodesMaiorValorTPM(treeData);
				setInputTPM(maiorFabrica);
				break;
			}
			case '3':{
				//LL maior valor da linha do pai
				let maiorLinha = checarNodesMaiorValorTPM(checarNodesRetornaFilhosDoPai(treeData, idStructure).nodes);
				setInputTPM(maiorLinha);
				break;
			}
			case '4':{
				//SubLL maior valor da linha do pai
				let maiorLinha = checarNodesMaiorValorTPM(checarNodesRetornaFilhosDoPai(treeData, idStructure).nodes);
				setInputTPM(maiorLinha);
				break;
			}
			case '5':{
				//Grupo maior valor da linha do pai
				let maiorLinha = checarNodesMaiorValorTPM(checarNodesRetornaFilhosDoPai(treeData, idStructure).nodes);
				setInputTPM(maiorLinha);
				break;
			}
			case '6': {
				setInputTPM(0);
				break;
			}
			case '7':{
				//Pilar maior valor da fabrica
				let maiorFabrica = checarNodesMaiorValorTPM(treeData);
				setInputTPM(maiorFabrica);
				break;
			}
			case '8': {
				//Ativo maior valor da linha do pai
				let maiorLinha = checarNodesMaiorValorTPM(checarNodesRetornaFilhosDoPai(treeData, idStructure).nodes);
				setInputTPM(maiorLinha);
				break;
			}
		
			default:
				break;
		}
	};

	const atualizarEstrutura = async ()=>{		
		const structureTree = await getStructureTreeBancoDeDados(getUserFactoryId());
		localStorage.setItem('StructureTree', JSON.stringify(structureTree));
	};

	useEffect(() => {
		async function initT(){
			setLoad(true)
			const structuresTree = await getStructureTree();
			const tree = structuresTree.structures
			setTreeData(tree);

			const factoryId = await getUserFactoryId();
			setFactoryId(factoryId)

			const structure = await getStructure(idStructure);
		   	setStructure(structure);

		  if(isAdd){
			  //funcao de adicionar
			let maiorFabrica = checarNodesMaiorValorTPM(tree);
			setInputTPM(maiorFabrica);
			setInputSetorArea({label:structure.name, id:idStructure});
		  }else{
			//funcao de editar
			console.log("Structure: " + structure);
			setInputNome(structure.name);
			setInputCode(structure.code);
			setInputTipo(structure.typeId);
			setInputTPM(structure.stepTpm);
			setValueStatus(structure.status);
			const setorAreaPai = checarNodesRetornaFilhosDoPai(tree, structure.fatherId);
			if(setorAreaPai){
				setInputSetorArea({label:setorAreaPai.label, id:setorAreaPai.structureId});
			}
		  }
		  setLoad(false)
		}
		initT();
	}, []);

	function checarNodesMaiorValorTPM(filho){
		let arrAux = 0;
		filho.forEach((e)=>{
			arrAux = e.step_tpm;
		  if(e.nodes.length > 0){
			let aux = checarNodesMaiorValorTPM(e.nodes);
			if(aux > arrAux){
				arrAux = aux;
			}
		  }
		})
		return arrAux;
	};
	function checarNodesRetornaFilhosDoPai(filho, pai){
		if(filho.length == 0)
		  return null;
		else{
		  let aux;
		  for(let i=0; i<filho.length; i++){
			if(filho[i].key == pai){
			  aux = filho[i];
			  break;
			}else{
			  aux = checarNodesRetornaFilhosDoPai(filho[i].nodes, pai);
			  if(aux)
				break;
			}
		  } 
		  return aux;
		}
	};

	return(
		<>
			<h1>{isAdd?`Criando uma nova área ou setor em baixo de`:`Editar área ou setor`} <b>{structure.name}</b></h1>

			{showModalOk ? (<ModalOk tittle={msgErro} ok={e=>setShowModalOk(false)}></ModalOk>):(null)}
			{showModalSuccess ? (<ModalOk tittle={msgSuccess} ok={handleModalSuccess}></ModalOk>):(null)}
			<div style={{position: 'relative'}}>
			{
				load ? 
				<Loading/>:null
			}
			<form noValidate>
				<Grid container spacing={2} className="mt-6 mb-6">
					<Grid container spacing={2}>
						<Grid item xs={12} md={4}>
							<h6>Nome</h6>
							<TextField 
								fullWidth 
								error={inputNomeErro}
								className="bg-color-white" 
								placeholder="Digite o nome" 
								onChange={e=>setInputNome(e.target.value)} 
								value={inputNome}
								margin="dense" size="small" variant="outlined" />
						</Grid>

						<Grid item xs={12} md={4}>
							<h6>Tipo</h6>
							<TextField
								id="outlined-select-classificacao"
								fullWidth
								error={inputTipoErro}
								className="bg-color-white" 
								select
								placeholder="Selecione um tipo" 
								onChange={e=>handleTipo(e.target.value)}
								value={inputTipo}
								SelectProps={{
									native: true,
								}}
								margin="dense" size="small" variant="outlined"
							>
								{listClassificao.map((option) => (
									<option  key={option.id} value={option.id}>
										{option.label}
									</option >
								))}
							</TextField>
						</Grid>

						{inputTipo == 6? (
							<Grid item xs={12} md={4}>
								<h6>Passo TPM</h6>
								<TextField 
									fullWidth 
									error={inputTPMErro}
									className="bg-color-white" 
									placeholder="Digite o nome" 
									onChange={e=>setInputTPM(e.target.value)} 
									value={inputTPM}
									margin="dense" size="small" variant="outlined" />
							</Grid>
						):null}
					</Grid>
					
					<Grid container spacing={2} className="mt-6">
							{(inputTipo == 9 || inputTipo == 8 || inputTipo == 6) &&
						<Grid item xs={12} md={4}>
								<h6>{(inputTipo == 9 || inputTipo == 8) ? 'FLOC(código do ativo)' : 'Sigla da linha na FLOC'}</h6>
							<TextField 
								fullWidth 
								error={inputCodeErro}
								className="bg-color-white" 
								placeholder="Digite o FLOC(código do ativo)" 
								onChange={e=>setInputCode(e.target.value)} 
								value={inputCode}
								margin="dense" size="small" variant="outlined" />
						</Grid>
						}

						{isAdd?(null):(
							<>
								<Grid item xs={12} sm={4} style={{"alignSelf": "flex-end"}}>
									<h6>Alterar pai (Setor/área acima)</h6>
									<TextField 
										fullWidth 
										inputProps={{
											readOnly: Boolean(true),
										}}
										error={inputSetorAreaErro}
										className="bg-color-white" 
										placeholder="Click aqui para selecionar o setor." 
										value={inputSetorArea.label}
										onClick={abrirModalSetor}
										margin="dense" size="small" variant="outlined" />
								</Grid>

								<Grid item xs={12} sm={4} style={{"align-self": "flex-end"}}>
									<h6 className="text-center">Status</h6>
									<div className="inner text-center">
										<ToggleButtonGroup
											style={{width: '100%'}}
											className="radio-button-custom"
											name="valueStatus"
											type="radio"
											value={valueStatus}
											onChange={handleChangeStatus}
										>
										<Form.Check 
											className="radio-1"
											type="radio"
											id={`default-radio-ativo`}
											label="Ativo"
											value={true}
										/>
										<Form.Check
											className="radio-1"
											type="radio"
											id={`default-radio-dasativo`}
											label="Desativo"
											value={false}
										/>
										</ToggleButtonGroup>
									</div>
								</Grid>
							</>
						)}
					</Grid>

					<Grid container spacing={2} className="mt-6">
						<Grid container item direction="row" justify="flex-end" xs={12}>
							{loading?(
								<CircularProgress color="primary" />
							):(
								<>
									<Link to={{
										pathname: `/home`,
										state: {}
									}}>
										<Button variant="danger" className="mr-8">
											Cancelar
										</Button>
									</Link>
										
									<Button variant="success" onClick={proximoPasso}>
										Salvar
									</Button>
								</>
							)}
						</Grid>
					</Grid>
				</Grid>
			</form>	
			</div>

			<Modal
				size="lg"
				show={showModalSetor}
				onHide={() => setShowModalSetor(false)}
				aria-labelledby="example-custom-modal-styling-title"
			>
				<Modal.Header closeButton>
				<Modal.Title id="example-custom-modal-styling-title">
					Selecione uma área ou linha da sua fábrica
				</Modal.Title>
				</Modal.Header>
				<Modal.Body>
				<TreeMenu
					data={treeData}
					onClickItem={handleShow}
					focused="false"
					hasSearch="false"
					initialOpenNodes={[treeData[0].key.toString()]}
					resetOpenNodesOnDataUpdate={true}
				>
					{({ search, items }) => (
					<ul
						style={{
						listStyleType: 'none',
						padding: '0',
						margin: '0',
						}}
					>
						{items.map(({ key, ...props }) =>
							<ItemComponent key={key} {...props} />
						)}
					</ul>
					)}
				</TreeMenu>
				</Modal.Body>
				<Modal.Footer>
				<Button variant="primary" onClick={fecharModalSetor}>
					Fechar
				</Button>
				</Modal.Footer>
			</Modal>
		</>
	)

};